/**
 * Auto-install settings grid for the Small Power tab.
 * Controlled — parent owns state.
 */
export default function AutoInstallSettings({
  code, setCode,
  spacing, setSpacing,
  targetFc, setTargetFc,
  withinFt, setWithinFt,
  mountIn, setMountIn,
  replace, setReplace,
}) {
  return (
    <div className="grid grid-cols-2 md:grid-cols-6 gap-3 mb-4 bg-[#0a0d12] border border-white/10 p-4">
      <div>
        <div className="label-tag mb-1">Code</div>
        <select
          value={code} onChange={(e) => setCode(e.target.value)}
          className="input-base text-sm" data-testid="small-power-code"
        >
          <option value="NEC">NEC</option>
          <option value="CEC">CEC</option>
        </select>
      </div>
      <div>
        <div className="label-tag mb-1">Max spacing (ft)</div>
        <input
          type="number" min="3" max="30" step="0.5"
          value={spacing} onChange={(e) => setSpacing(Number(e.target.value) || 12)}
          className="input-base text-sm" data-testid="small-power-spacing"
        />
      </div>
      <div>
        <div className="label-tag mb-1">Target fc</div>
        <input
          type="number" min="10" max="200" step="5"
          value={targetFc} onChange={(e) => setTargetFc(Number(e.target.value) || 50)}
          className="input-base text-sm" data-testid="small-power-fc"
        />
      </div>
      <div>
        <div className="label-tag mb-1">Service within (ft)</div>
        <input
          type="number" min="5" max="50" step="1"
          value={withinFt} onChange={(e) => setWithinFt(Number(e.target.value) || 25)}
          className="input-base text-sm" data-testid="small-power-within"
        />
      </div>
      <div>
        <div className="label-tag mb-1">Mount height (in)</div>
        <input
          type="number" min="6" max="120" step="1"
          value={mountIn} onChange={(e) => setMountIn(Number(e.target.value) || 18)}
          className="input-base text-sm" data-testid="small-power-mount"
        />
      </div>
      <div>
        <div className="label-tag mb-1">Mode</div>
        <select
          value={replace ? "replace" : "merge"}
          onChange={(e) => setReplace(e.target.value === "replace")}
          className="input-base text-sm" data-testid="small-power-mode"
        >
          <option value="replace">Replace existing</option>
          <option value="merge">Merge / append</option>
        </select>
      </div>
    </div>
  );
}
